import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * Extension registrations for the GitHub Migration screens.
 *
 * `name` is mandatory on the page: an unnamed PageBlueprint in the `app` plugin
 * would collide with the existing rootRedirectPage, which is `page:app`.
 */

export const gitHubMigrationPage = PageBlueprint.make({
  name: 'github-migration',
  params: {
    path: '/github-migration',
    loader: () =>
      import('./GitHubMigrationPage').then(m => <m.GitHubMigrationPage />),
  },
});

export const groupMigrationContent = EntityContentBlueprint.make({
  name: 'github-migration',
  params: {
    path: '/github-migration',
    title: 'GitHub Migration',
    group: 'deployment',
    // Team groups only — not the leads/developers/supports subgroups, which
    // have no services of their own.
    filter: { kind: 'group', 'spec.type': 'team' },
    loader: () =>
      import('./GroupMigrationContent').then(m => <m.GroupMigrationContent />),
  },
});

export const componentMigrationContent = EntityContentBlueprint.make({
  name: 'github-migration-component',
  params: {
    path: '/github-migration',
    title: 'GitHub Migration',
    filter: { kind: 'component' },
    loader: () =>
      import('./ComponentMigrationContent').then(m => (
        <m.ComponentMigrationContent />
      )),
  },
});
